import ClientsIcon from './ClientsIcon';

export default ClientsIcon;
